import { useQuery } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

// Prophet page config change history (prophet.pageConfigAudit),
// sorted by `at` desc on the server.
export const getProphetPageAudit: prophetTypes.GetProphetPageAudit = (params) => {
  return axios.get('/prophet/pages/audit', { params });
};

type QueryFnType = typeof getProphetPageAudit;

type UseGetProphetPageAuditOptions = {
  pageId: string;
  page: number;
  limit: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetProphetPageAudit = ({
  config = {},
  pageId,
  page,
  limit,
}: UseGetProphetPageAuditOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    keepPreviousData: true,
    // Opt out of the global refetchOnMount: false. Every mutation that writes an
    // audit record happens on the pages list, where this query is inactive, and
    // invalidateQueries only refetches active queries — a query marked stale is
    // not refetched on mount while refetchOnMount is false, so the history would
    // keep serving the cached page until cacheTime expires.
    refetchOnMount: true,
    ...config,
    queryKey: ['prophet-page-audit', pageId, page, limit],
    enabled: !!pageId,
    queryFn: () => getProphetPageAudit({ pageId, skip: (page - 1) * limit, limit }),
  });
};
